import { TPermissionItem } from "@/data/types";
import { State } from "../state/state";

export const getAllPermissions = (state: State): TPermissionItem[] => state.permissions.items;

export const getCurrentPermission = (state: State): TPermissionItem | null =>
  state.permissions.currentPermission;